export default "__VITE_ASSET__8XsXDBJW__"